import { Injectable } from '@angular/core';

import * as sdk from '@mycure/sdk';
import { MycureSDK } from './../service';

import { Logger } from '../logger/logger.service';
const log = new Logger('NotificationService');

@Injectable({
  providedIn: 'root'
})

export class McOrganizationService {

  constructor(
    private sdk: MycureSDK,
  ) {

  }

  loadOrg(id: string) {
    return this.sdk.organizations().get(id);
  }

  isOrgActive(): boolean {
    return localStorage.getItem('organization')
      && localStorage.getItem('organization') != 'undefined' ? true : false;
  }

  setActiveOrganization(item: string) {
    localStorage.setItem('organization', item);
  }

  setOrgMembership(item: any) {
    const itemString = JSON.stringify(item);
    localStorage.setItem('orgMembership', itemString);
  }

  getOrgMembership(): any {
    return localStorage.getItem('orgMembership');
  }

  /**
   * returns undefined when no active organization
   */
  getActiveOrganization(): string {
    const organizationId = localStorage.getItem('organization');
    return organizationId;
  }

  /**
   * Get base role (first item inside roles)
   * @param membership - organization membership object
   */
  getBaseRoleMembership(membership: any): string {
    if (membership.superadmin) return 'admin';

    if (membership.roles && membership.roles.length != 0) {
      const type: string = membership.roles[0];

      if (type.includes('frontdesk')) {
        return 'FrontDesk';
      } else if (type.includes('frontdesk_head')) {
        return 'FrontDesk: Head';
      } else if (type.includes('frontdesk_encoder')) {
        return 'HMO Encoder';
      }

      if (type.includes('nurse')) {
        return 'Nurse';
      } else if (type.includes('nurse_head')) {
        return 'Nurse: Head';
      }

      if (type.includes('doctor')) {
        return 'Doctor';
      } else if (type.includes('doctor_pathologist')) {
        return 'Doctor: Pathologist';
      } else if (type.includes('doctor_radiologist')) {
        return 'Doctor: Radiologist';
      } else if (type.includes('doctor_sonologist')) {
        return 'Doctor: Sonologist';
      }

      if (type.includes('lab_tech')) {
        return 'Lab: Technologist';
      } else if (type.includes('lab_qc')) {
        return 'Lab: QC';
      } else if (type.includes('lab_head')) {
        return 'Lab: Head';
      }

      if (type.includes('imaging_tech')) {
        return 'Imaging: Technologist';
      } else if (type.includes('imaging_qc')) {
        return 'Imaging: QC';
      } else if (type.includes('imaging_head')) {
        return 'Imaging: Head';
      }

      if (type.includes('billing')) {
        return 'Billing: Cashier';
      } else if (type.includes('billing_encoder')) {
        return 'Billing: HMO Encoder';
      } else if (type.includes('billing_head')) {
        return 'Billing: Head';
      }

      if (type == 'admin') {
        return 'Admin';
      } else if (type == 'admin_analyst') {
        return 'Admin: Data Analyst';
      }

      if (type == 'warehouse') {
        return 'Inventory: Custodian';
      } else if (type == 'warehouse_manager') {
        return 'Inventory: Manager';
      } else if (type == 'warehouse_head') {
        return 'Inventory: Admin';
      }
    }

    return '';
  }

  getSavedBaseRoleMembership(): string {
    const _membership: any = localStorage.getItem('orgMembership');
    const membership = JSON.parse(_membership);

    if (membership) {
      if (membership.superadmin) return 'superadmin';
      const roles: string[] = membership.roles || [];
      if (roles.length != 0) {
        const type: string = membership.roles[0];
        if (type.includes('admin')) {
          return 'admin';
        } else if (type.includes('doctor')) {
          return 'doctor';
        } else if (type.includes('frontdesk')) {
          return 'frontdesk';
        } else if (type.includes('nurse')) {
          return 'nurse';
        } else if (type.includes('lab')) {
          return 'lab';
        } else if (type.includes('imaging')) {
          return 'imaging';
        } else if (type.includes('warehouse')) {
          return 'warehouse';
        } else if (type.includes('billing')) {
          return 'billing';
        }
      }
    }

    return undefined;
  }

  private isOrgMember(type: string = 'frontdesk'): boolean {
    const orgMembership: any = localStorage.getItem('orgMembership');
    if (orgMembership) {
      const roles: string[] = orgMembership.roles;
      const existing = roles.filter(item => item.includes(type));
      return existing.length != 0;
    }

    return false;
  }

  async loadOrgParentSiblingOrgIds(orgId: string) {
    let orgIds: string[] = [];

    // get parent facility if applicable
    const current = await this.sdk.organizations().get(orgId);
    if (!current) throw new Error('no organization');

    // if child, add parent id
    if (current.parent) orgIds.push(current.parent);

    // add self id
    orgIds.push(orgId);

    // if org is a child, get it's siblings
    // if org is a parent, get it's child
    const query: any = current.parent
      ? { parent: current.parent }
      : { parent: orgId };

    const orgs = await this.sdk.organizations().find(query);
    const ids: string[] = orgs.items.map(item => item.id);
    orgIds = orgIds.concat(ids);

    return orgIds;
  }

  async loadOrgPricingTypes(orgId: string) {
    const res = await this.sdk.organizations().get(orgId);
    if (!res) throw new Error('no organization');
    return res.bl_priceLists || [];
  }

  async loadOrgPxTags(orgId: string) {
    const res = await this.sdk.organizations().get(orgId);
    if (!res) throw new Error('no organization');
    return res.tags || [];
  }

  createOrgPxTag(orgId: string, tag: string) {
    const update: any = { $addToSet: { tags: tag } };
    return this.sdk.organizations().update(orgId, update);
  }

  setOrgKioskPrinting(orgId: string, isPrintingEnabled: boolean = true) {
    const update: any = { queue_printNo: isPrintingEnabled };
    return this.sdk.organizations().update(orgId, update);
  }

  removeOrgPxTag(orgId: string, tag: string) {
    const update: any = { $pull: { tags: tag } };
    return this.sdk.organizations().update(orgId, update);
  }
}
